import IconWithFallback from "Global/IconWithFallback";
import ConnectedAmountPercentInputs from "common/Inputs/ConnectedAmountPercentInputs";
import Modal from "common/Modal/Modal";
import Text from "common/Typography/Text";
import useKeyPressWithCallback from "utils/hooks/useKeyPressWithCallback";
import { AddAmountModalProps } from "@shared/features/trades/EditTrade/types";
import { typography } from "@shared/common/Themes/typography";
import { ICON_TYPES } from "@shared/common/constants";
import { useAddAmountModal } from "@shared/features/trades/EditTrade/hooks";
import { PERCENT_PRECISION } from "@shared/features/tradingTerminal/common/constants.ts";

const AddAmountModal = ({
  closeModal,
  amountData,
  onSave,
  validateMinAmount,
}: AddAmountModalProps) => {
  const {
    onOkClick,
    isError,
    showSlider,
    availableAmount,
    amountInputValue,
    setAmountInputValue,
    modalData,
  } = useAddAmountModal({
    closeModal,
    amountData,
    onSave,
    validateMinAmount,
  });

  useKeyPressWithCallback("Enter", isError ? undefined : onOkClick);

  return (
    <Modal
      open={true}
      onCancel={closeModal}
      centered={true}
      closable={false}
      title={modalData.title}
      onOk={onOkClick}
      okButtonProps={{ disabled: modalData.disabled }}
    >
      <Text style={{ marginBottom: 12 }}>{modalData.text}</Text>
      <ConnectedAmountPercentInputs
        amountPrecision={amountData.precision}
        percentPrecision={PERCENT_PRECISION}
        availableAmount={availableAmount}
        amount={amountInputValue === "0" ? undefined : amountInputValue}
        onAmountChange={setAmountInputValue}
        maxPercent={100}
        icon={
          amountData.coin && (
            <IconWithFallback
              iconType={ICON_TYPES.COIN}
              coinOrExchangeName={amountData.coin}
              iconStyle={{ marginRight: 4 }}
            />
          )
        }
        showSlider={showSlider}
        useDebounce={false}
      />
      <Text
        style={{ marginTop: 4 }}
        type={isError ? "danger" : "secondary"}
        $size={typography.fontSizes.S}
      >
        {modalData.validationMessage}
      </Text>
    </Modal>
  );
};

export default AddAmountModal;
